module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "FM_Title"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('strong', [_vm._v("BRINGING"), _c('br'), _vm._v("DOWN"), _c('br'), _vm._v("GADDAFI")])]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FM_Title"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "id": "tit"
    }
  }, [_c('strong', [_vm._v("BRINGING"), _c('br'), _vm._v("DOWN"), _c('br'), _vm._v("GADDAFI")])])]), _c('a', {
    attrs: {
      "id": "tit"
    }
  }, [_c('p', {
    staticClass: "FM_SubTitle"
  }, [_vm._v("ON THE GROUND WITH THE LIBYAN REBELS")]), _vm._v(" "), _c('p', {
    staticClass: "FM_Author"
  }, [_vm._v("ANDREI NETTO")]), _vm._v(" "), _c('p', {
    staticClass: "FM_Author1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RANSLATED BY")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICHAEL")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARSDEN")])]), _vm._v(" "), _c('p', {
    staticClass: "pub"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/pub.jpg"
    }
  })])]), _c('p', {
    staticClass: "break"
  }, [_c('a', {
    attrs: {
      "id": "tit"
    }
  }, [_c('br'), _c('br')]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "3.0em",
      "text-align": "justify"
    },
    attrs: {
      "id": "notice"
    }
  }, [_vm._v("The author and publisher have provided this e-book to you for your personal use only. You may not make this e-book publicly available in any way. "), _c('strong', [_vm._v("Copyright infringement is against the law. If you believe the copy of this e-book you are reading infringes on the author’s copyright, please notify the publisher at: "), _c('a', {
    attrs: {
      "href": "http://us.macmillanusa.com/piracy",
      "target": "_blank"
    }
  }, [_vm._v("us.macmillanusa.com/piracy")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "PrelimTitle"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('p', {
    staticClass: "Tocb"
  }, [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/9781137279125_01_Pre#ack"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9781137279125_02_Ch01#Ch1"
    }
  }, [_vm._v("Chapter 1: The End")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9781137279125_03_Ch02#Ch2"
    }
  }, [_vm._v("Chapter 2: Rebirth")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781137279125_04_Ch03#Ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Spring")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781137279125_05_Ch04#Ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Revolution")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781137279125_06_Ch05#Ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Secret")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781137279125_07_Ch06#Ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Risk")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781137279125_08_Ch07#Ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Betrayal")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781137279125_09_Ch08#Ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Intervention")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781137279125_10_Ch09#Ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Plan")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781137279125_11_Ch10#Ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Downfall")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781137279125_12_Ch11#Ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Silence")])]), _vm._v(" "), _c('p', {
    staticClass: "Tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781137279125_13_Epil#epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781137279125_14_Tim#tim",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Timeline")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781137279125_15_Bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781137279125_16_Ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "PrelimTitle"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "ack"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _c('a', {
    attrs: {
      "id": "ack"
    }
  }), _c('p', {
    staticClass: "DropText"
  }, [_c('a', {
    attrs: {
      "id": "ack"
    }
  }, [_vm._v("I would like to thank Lucia Müzell, M.T. Leal de Moraes, and Vinicius M. Netto for their support, Iran Garcia and Amal Daredi for their personal commitment to securing my release, and my management team Fuad Allen Lloyd and Kojo Bentil for their friendship and help in sharing this project.")]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d6e3008","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9781137279125_01_Pre.vue
// module id = 60
// module chunks = 0